module.exports = __webpack_public_path__ + "img/shivam.c1224416.png";